import type { TeamSummary } from '@/lib/types'
import { formatDate, formatRelative } from '@/lib/format'
import { UsageBar } from './meters'

export function TeamNameCell({ team }: { team: TeamSummary }) {
  return (
    <div className="min-w-0 leading-tight">
      <div className="truncate font-medium">{team.name || `Team ${team.id}`}</div>
      <div className="truncate text-xs text-muted-foreground">{team.owner?.email || team.owner?.uid || 'No owner'}</div>
    </div>
  )
}

export const MembersCell = ({ team }: { team: TeamSummary }) => <UsageBar value={team.members} limit={team.limits.users} className="min-w-20" />
export const CompaniesCell = ({ team }: { team: TeamSummary }) => <UsageBar value={team.companies} limit={team.limits.companies} />

export function RenewsCell({ team }: { team: TeamSummary }) {
  const s = team.subscription
  if (!s.expires_at) return <span className="text-muted-foreground">—</span>
  const verb = s.state === 'canceling' ? 'Ends' : s.state === 'expired' ? 'Ended' : 'Renews'
  return (
    <div className="leading-tight">
      <div>
        {verb} {formatDate(s.expires_at)}
      </div>
      <div className="text-xs text-muted-foreground">{formatRelative(s.expires_at)}</div>
    </div>
  )
}
